import { render, staticRenderFns } from "./IconTypeformNumber.vue?vue&type=template&id=01204b26&"
import script from "./IconTypeformNumber.vue?vue&type=script&lang=ts&"
export * from "./IconTypeformNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports